import React, { PropsWithChildren, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Spin } from 'antd';
import { withProperty, useGet } from 'shared';

interface OrgContext {
  id: string;
  email: string;
  org_name: string;
}

const orgContext = React.createContext<OrgContext>({
	id: '',
	email: '',
  org_name: '',
});

export const useOrg = () => useContext(orgContext);

export const OrgContext = ({ children }: PropsWithChildren) => {
  const [data, error, fetching] = useGet<OrgContext>("/api/org");
	
  const navigate = useNavigate();
  useEffect(() => {
    if (error) {
      navigate('/login');
    }
    // navigate changes with the location: with it, this would redirect again
    // on every page change while the error stands
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

	if (fetching || !data) {
		return <Spin />;
	}

	if (!withProperty(data, 'org_name')) {
		throw new Error(`${(data as { email?: string }).email ?? '?'} not tied to an organization!`);
	}

	return <orgContext.Provider value={data}>{children}</orgContext.Provider>;
};

